import { useSurvey, Survey } from "@tree-company/tree-query";

export function Progress({ survey }: { survey: Survey }) {
  const { progress } = useSurvey(survey);

  return (
    <span className="progress">
      <span
        className="progress__track"
        style={{ width: `${progress * 100}%` }}
      ></span>
    </span>
  );
}
